import { render } from "./CodeView.vue?vue&type=template&id=bffa1fe0&scoped=true&ts=true"
import script from "./CodeView.vue?vue&type=script&lang=ts"
export * from "./CodeView.vue?vue&type=script&lang=ts"

import "./CodeView.vue?vue&type=style&index=0&id=bffa1fe0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bffa1fe0"]])

export default __exports__